import React from 'react';

const OnStatusRemovedContext = React.createContext(null);

export default OnStatusRemovedContext;
